import Vue from "vue"
import BaseActionButton from '@/modules/global/components/BaseButton'

// Registering the component globally
Vue.component('BaseActionButton', BaseActionButton)